import React from 'react'
import {Controller} from 'react-hook-form'
import {Sponsor} from 'Event/Sponsors'
import {useConfig} from 'organization/Event/Configurable'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import ColorPicker from 'lib/ui/ColorPicker'
import BaseConfig from 'Event/Sponsors/SponsorConfig'
import {useNiftyFiftyTemplate} from 'Event/template/NiftyFifty'

export default function SponsorConfig(props: {id: string; sponsor: Sponsor}) {
  const {sponsors, textColor} = useNiftyFiftyTemplate()
  const {
    form: {control},
  } = useConfig()
  const nameColor = props.sponsor.nameColor ?? sponsors.nameColor ?? textColor

  return (
    <BaseConfig
      {...props}
      stylingPanel={
        <StylingPanel>
          <Controller
            name={`sponsors.items.${props.id}.nameColor`}
            defaultValue={nameColor}
            control={control}
            render={({value, onChange}) => (
              <ColorPicker
                label="Name Color"
                color={value}
                onPick={onChange}
                aria-label="sponsor name color"
              />
            )}
          />
        </StylingPanel>
      }
    />
  )
}
